import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { RouteError } from '@/components/RouteError';
import { HomePage } from '@/routes/HomePage';
import { SearchPage } from '@/routes/SearchPage';
import { CategoryPage } from '@/routes/CategoryPage';
import { SignPage } from '@/routes/SignPage';
import { FavoritesPage } from '@/routes/FavoritesPage';
import { RecentPage } from '@/routes/RecentPage';
import { DownloadsPage } from '@/routes/DownloadsPage';
import { StudyPage } from '@/routes/StudyPage';
import { SettingsPage } from '@/routes/SettingsPage';
import { DiagnosticsPage } from '@/routes/DiagnosticsPage';

/** Rotas do MVP (PLAN §44). */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'search', element: <SearchPage /> },
      { path: 'category/:categoryId', element: <CategoryPage /> },
      { path: 'sign/:signId', element: <SignPage /> },
      { path: 'favorites', element: <FavoritesPage /> },
      { path: 'recent', element: <RecentPage /> },
      { path: 'downloads', element: <DownloadsPage /> },
      { path: 'study', element: <StudyPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'diagnostics', element: <DiagnosticsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
